import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Events/FutureOfFreight/components/SectionSignUp/SectionSignUp.module.scss';

const cn = classNames.bind(styles);

const SectionSignUp = (): ReactElement => {
  return (
    <section className={cn('sign-up')} id="registration">
      <div className={cn('container')}>
        <p className={cn('sign-up__title')}>
          <span className={cn('sign-up__title-span')}>DFA Conference on</span>
          <span className={cn('sign-up__title-span')}>Digitalization and the Future of Freight</span>
        </p>
        <div className={cn('sign-up__button-box')}>
          <a
            href="https://www.youtube.com/watch?v=fRpK-6Ck9AY&ab_channel=DigitalFreightAlliancebyDPWorld"
            className={cn('sign-up__button')}
          >
            Follow online
          </a>
        </div>
      </div>
    </section>
  );
};

export default SectionSignUp;